import { useEffect } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "../utils/permissions";

export const useHasPermission = (perm) => {
  const permissions = useSelector((state) => state.auth.permissions);
  return hasPermission(permissions, perm);
};

export const usePermissions = () => {
  return useSelector((state) => state.auth.permissions) || [];
};

export const useRequirePermission = (perm, onNavigate) => {
  const hasPerm = useHasPermission(perm);

  useEffect(() => {
    if (perm && !hasPerm && onNavigate) {
      onNavigate("/home");
    }
  }, [perm, hasPerm, onNavigate]);

  return hasPerm;
};
